import { createI18n } from 'vue-i18n';
import { LocaleTypes } from '~/utils/enums';

const i18n = createI18n({
  locale: LocaleTypes.DEFAULT,
  fallbackLocale: LocaleTypes.DEFAULT,
  silentFallbackWarn: true,
  legacy: false,
  availableLocales: [LocaleTypes.RU, LocaleTypes.EN],
  dateTimeFormats: {
    [LocaleTypes.EN]: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      }
    },
    [LocaleTypes.RU]: {
      short: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }
    }
  }
});

export function setLocale(locale: string) {
  i18n.global.locale.value = locale;
}

export default i18n;
